import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getTaskStaffDetail } from "@api/correspondence/task";
export default {
  name: 'index',
  props: {
    id: {
      required: true
    }
  },
  data: function data() {
    return {
      list: [],
      isOver: false,
      loading: false
    };
  },
  methods: {
    getStaffs: function getStaffs() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loading = true;
              _context.n = 1;
              return getTaskStaffDetail({
                TaskId: _this.id
              });
            case 1:
              data = _context.v;
              _this.list = data.data;
              _this.isOver = true;
              _this.loading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    init: function init() {
      if (this.id) {
        this.getStaffs();
        // if (!this.isOver) {
        //   this.getStaffs()
        // }
      }
    }
  },
  created: function created() {}
};